import React from "react";
import { Navigate } from "react-router-dom";
import useCurrentUserAccess from "../hooks/useCurrentUserAccess";

export default function UserManagementRoute({ children }) {
  const { loading, platformRole, accountRole } = useCurrentUserAccess();

  if (loading) return null;

  const isPlatformAdmin = platformRole?.key_name === "platform_admin";
  const isAccountAdmin = accountRole?.key_name === "account_admin";

  if (!isPlatformAdmin && !isAccountAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}